import { DEFAULT_COL_WIDTH } from '../constants.js'

export function parseHTMLColWidth(node: Element) {
  const cellIndex = Array.from(node.parentElement.children).indexOf(node)

  // Get colspan value (defaults to 1 if not set)
  const colspan = parseInt(node.getAttribute('colspan') || '1', 10)

  // Get all col elements
  const cols =
    node.parentElement.parentElement.parentElement.querySelectorAll('col')

  // Create an array of widths based on colspan
  const widths = []
  for (let i = 0; i < colspan; i++) {
    const col = cols[cellIndex + i]
    const width = parseInt(col?.style?.width?.replace('px', ''), 10)
    widths.push(width || DEFAULT_COL_WIDTH) // Use default width if not specified
  }

  return widths.length ? widths : undefined
}
